import { useQuery } from "@apollo/client"
import { FullTeamProfile } from "@pallet/features/RecruitingTeamType/FullTeamProfile"
import { LikeTeamAction } from "@pallet/features/RecruitingTeamType/LikeTeamAction"
import { BaseModal, Box, theme } from "@pallet-hq/hegel"
import mixpanel from "mixpanel-browser"
import { useEffect } from "react"
import { TRACK_EVENTS } from "constants/events"
import { useTeamProfileModal } from "./hooks"
import { TEAM_PROFILE_MODAL_QUERY } from "./queries"
import { TeamProfileModalQuery } from "__generated__/TeamProfileModalQuery"

const TeamProfileModal = () => {
    const { isOpen, hideModal, team } = useTeamProfileModal()

    const { data, loading, error } = useQuery<TeamProfileModalQuery>(
        TEAM_PROFILE_MODAL_QUERY,
        {
            variables: { team },
            skip: !isOpen,
        }
    )

    useEffect(() => {
        if (isOpen) {
            mixpanel.track(TRACK_EVENTS.TEAM_COMPANY_PROFILE_VIEWED, {
                team: team,
            })
        }
    }, [team, isOpen])

    if (loading || error || !data) return null

    return (
        <BaseModal
            style={{
                overlay: {
                    backgroundColor: theme.colors.black4,
                    zIndex: 2,
                },
                content: {
                    top: "50%",
                    left: "50%",
                    right: "auto",
                    bottom: "auto",
                    marginRight: "-50%",
                    transform: "translate(-50%, -50%)",
                    width: "100%",
                    height: "calc(100% - 80px)",
                    maxWidth: "680px",
                    maxHeight: "100%",
                    borderRadius: "8px",
                    boxShadow:
                        "0px 1px 6px rgba(0, 0, 0, 0.16), 0px 6px 20px rgba(0, 0, 0, 0.2)",
                },
            }}
            isOpen={isOpen}
            hideModal={hideModal}
        >
            <Box maxWidth="680px" p="40px 20px" mx="auto">
                <FullTeamProfile
                    team={data.recruitingTeam}
                    action={<LikeTeamAction team={data.recruitingTeam} />}
                />
            </Box>
        </BaseModal>
    )
}

export { TeamProfileModal }
